<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1><i class="fas fa-building"></i> Tenant Manager</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 table-area">
          <div class="card">
            <div class="overlay" *ngIf="scope.wait">
              <i class="fas fa-spinner fa-spin"></i>
            </div>
            <div class="card-header with-border">
              <h3 class="card-title">カメラ一覧</h3>
              <div class="float-right">
                <button mat-raised-button (click)="save()" color="warn">Save</button>
              </div>
  
            </div>
            <div class="card-body">
              <div>
                ※チェックボックスでDashboardでの表示の切り替えが出来ます。
              </div>
              <table class="table table-bordered">
                <tbody>
                  <tr *ngFor="let camera of scope.cameras">
                    <td height="100px" class="contoller-group">
                      <video class="capture" autoplay muted #videoPlayer>
                        <source [src]="getCapture(camera.streamId)" />
                      </video>
                      <mat-checkbox class="add-toggle" (change)="toggle(camera)" [checked]="camera.select" ></mat-checkbox>
                      <div class="text-group">
                        <!-- {{ camera.streamName }}<br> -->
                        <a href="/#/stream/detail/{{camera.streamId}}" 
                        style="color: #006DF7;"
                        (mouseover)="mouseover($event)" 
                        (mouseout)="mouseout($event)">
                          {{ camera.streamName }}<br>
                        </a>
                        <div class="small-text">
                          Stream ID : {{camera.streamId}}<br>
                          保存期間 : {{camera.dataRetentionInHours}}時間
                        </div>
                      </div>
                      <button class="setting-btn" mat-raised-button color="accent" [routerLink]="['/stream/detail', camera.streamId]" >設定</button>
                    </td>
                  </tr>
                </tbody>
              </table>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>